// Part of the Chili3d Project, under the AGPL-3.0 License.
// See LICENSE file in the project root for full license information.

export class Constants {
    static readonly DBName = "diorama-cad-db";
    static readonly DocumentTable = "documents";
    static readonly RecentTable = "recents";
}
